import { Pipe, PipeTransform } from '@angular/core';
import { LocationType } from '../../messages/model/location-type';

@Pipe({
  name: 'locationTypeName'
})
export class LocationTypePipe implements PipeTransform {

  transform(locationType: LocationType | null): string {
    if (locationType == null)
      return null;
    return getLocationTypeName(locationType);
  }
}

export function getLocationTypeName(locationType: LocationType): string {
  return Object.keys(LocationType)[Object.values(LocationType).indexOf(locationType)];
}
